<template>
  <section class=""
           style="padding-top: 1.5rem">
    <div class="container">

      <div class="columns">
        <div class="column"></div>
        <div class="column is-three-quarters">
          <!-- <div>
                    Edit: {{ uploadResponse.fileId }}   
                  </div>   
                  <br> -->

          <!-- <section class="" style="padding-top: 1.5rem"> -->
          <!-- <div class="container"> -->

          <div class="box">
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Use text from:</label>
              </div>
              <div class="field-body">
                <div class="field is-grouped">
                  <span class="button"
                        :class="{'is-info is-selected': useTextFrom === 'Slide'}"
                        @click="setUseTextFromAs('Slide')"
                        v-tooltip.top="{ 
                          html: 'tooltip-content-useslidetext',
                          delay: 0
                        }">Slide</span>
                  <span class="button"
                        :class="{'is-info is-selected': useTextFrom === 'Notes'}"
                        @click="setUseTextFromAs('Notes')"
                        v-tooltip.top="{ 
                          html: 'tooltip-content-usenotestext',
                          delay: 0
                        }">Notes</span>
                  <span class="button"
                        :class="{'is-info is-selected': useTextFrom === 'Blank'}"
                        @click="setUseTextFromAs('Blank')"
                        v-tooltip.top="{ 
                          html: 'tooltip-content-useblank',
                          delay: 0
                        }">Blank</span>
                </div>
              </div>
            </div>

            <!-- <div class="field is-horizontal">
                  <div class="field-label">
                    <label class="label">Use slide text:</label>
                  </div>
                  <div class="field-body">
                    <div class="field">
                      <p class="control">
                        <b-switch v-model="useSlideText"
                                  true-value="Yes"
                                  false-value="No"
                                  type="is-info">
                          {{ useSlideText }}
                        </b-switch>
                      </p>
                    </div>
                    <span class="icon is-small vertical-center"
                          v-tooltip.bottom="{ 
                                html: 'tooltip-content-useslidetext'
                              }">
                      <i class="fa fa-question-circle-o"></i>
                    </span>
                  </div>
                </div>

                <div class="field is-horizontal">
                  <div class="field-label">
                    <label class="label">Use notes text:</label>
                  </div>
                  <div class="field-body">
                    <div class="field">
                      <p class="control">
                        <b-switch v-model="useNotesText"
                                  true-value="Yes"
                                  false-value="No"
                                  type="is-info">
                          {{ useNotesText }}
                        </b-switch>
                      </p>
                    </div>
                    <span class="icon is-small vertical-center"
                          v-tooltip.bottom="{ 
                                html: 'tooltip-content-usenotestext'
                              }">
                      <i class="fa fa-question-circle-o"></i>
                    </span>
                  </div>
                </div> -->

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Add to start:</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <p class="control has-icons-right">
                    <input class="input"
                           type="text"
                           placeholder="Text to add at the start of each slide's tweet, e.g. [slideNum]/[totalSlides]:\n"
                           v-model="prefixTextTemplate">
                      <span class="icon is-right is-clickable">
                        <a class="delete is-small"
                           title="Clear"
                           v-if="prefixTextTemplate.length"
                           @click="prefixTextTemplate = ''"></a>
                      </span>
                  </p>             
                </div>
                <!-- <b-tooltip label="Text to add at the start of each slide's tweet.<br>You can"
                                   multilined
                                   position="is-bottom  ">
                          <span class="icon vertical-center"><i class="fa fa-info-circle"></i></span> 
                        </b-tooltip> -->
                <span class="icon is-small vertical-center"
                      v-tooltip.bottom="{ 
                                html: 'tooltip-content-addtostart'
                              }">
                  <i class="fa fa-question-circle-o"></i>
                </span>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Add to end:</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <p class="control has-icons-right">
                    <input class="input"
                           type="text"
                           placeholder="Text to add at the end of each slide's tweet, e.g. #TweetMySlides"
                           v-model="suffixTextTemplate">
                      <span class="icon is-right is-clickable">
                        <a class="delete is-small"
                           title="Clear"
                           v-if="suffixTextTemplate.length"
                           @click="suffixTextTemplate = ''"></a>
                      </span>                           
                  </p>
                </div>
                <!-- <b-tooltip label="Tooltip right"
                                   position="is-right">
                          <span class="icon vertical-center"><i class="fa fa-info-circle"></i></span> 
                        </b-tooltip>                   -->
                <span class="icon is-small vertical-center"
                      v-tooltip.bottom="{ 
                                html: 'tooltip-content-addtoend'
                              }">
                  <i class="fa fa-question-circle-o"></i>
                </span>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label">
                <label class="label">Add credits tweet:</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <p class="control">
                    <b-switch v-model="includeCreditTweet"
                              true-value="Yes"
                              false-value="No"
                              type="is-info">
                      {{ includeCreditTweet }}
                    </b-switch>
                  </p>
                </div>
                <span class="icon is-small vertical-center"
                      v-tooltip.bottom="{ 
                            html: 'tooltip-content-usecreditstweet'
                          }">
                  <i class="fa fa-question-circle-o"></i>
                </span>
              </div>
            </div>

          </div>

          <div id="tooltip-content-useslidetext">
            <p>Use the text extracted from the
              <b>slide</b> as the content of each tweet.</p>
            <br>
            <p>
              <b>Warning:</b> Changing this option will replace any edits you have already made.</p>
          </div>
          <div id="tooltip-content-usenotestext">
            <p>Use the text extracted from the slide
              <b>notes</b> as the content of each tweet.</p>
            <br>
            <p>For more details on using notes, see:
              <a href="https://support.office.com/en-us/article/Add-speaker-notes-to-your-slides-26985155-35F5-45BA-812B-E1BD3C48928E"
                 target="_blank">https://support.office.com/en-us/article/Add-speaker-notes-to-your-slides-26985155-35F5-45BA-812B-E1BD3C48928E</a>
            </p>
            <br>
            <p>
              <b>Warning:</b> Changing this option will replace any edits you have already made.</p>
          </div>
          <div id="tooltip-content-useblank">
            <p>Sets the content of each tweet as <b>blank</b></p>
            <br>
            <p>
              <b>Warning:</b> Changing this option will replace any edits you have already made.</p>
          </div>          
          <div id="tooltip-content-addtostart">
            <p>Text to add at the
              <b>start</b> of each slide's tweet, such as the current slide number.</p>
            <br>
            <p>You can use the following special markup:</p>
            <br>
            <ul style="list-style-type: circle;">
              <li style="margin-left: 15px;">
                <b>[slideNum]</b> - will be replaced with the number of the current slide.</li>
              <li style="margin-left: 15px;">
                <b>[totalSlides]</b> - will be replaced with the total number of slides.</li>
              <li style="margin-left: 15px;">
                <b>\n</b> - will be replaced with a newline.</li>
            </ul>
            <br>
            <p>Example: '<b>[slideNum]</b>/<b>[totalSlides]</b><b>\n</b>' - <a @click="prefixTextTemplate = '[slideNum]/[totalSlides]:\\n'">Use this</a></p>
          </div>
          <div id="tooltip-content-addtoend">
            <p>Text to add at the
              <b>end</b> of each slide's tweet, such as a #hashtag.</p>
            <br>
            <p>You can use the following special markup:</p>
            <br>
            <ul style="list-style-type: circle;">
              <li style="margin-left: 15px;">
                <b>[slideNum]</b> - will be replaced with the number of the current slide.</li>
              <li style="margin-left: 15px;">
                <b>[totalSlides]</b> - will be replaced with the total number of slides.</li>
              <li style="margin-left: 15px;">
                <b>\n</b> - will be replaced with a newline.</li>
            </ul>
            <br>
            <p>Example: '<b>\n#TweetMySlides</b>' - <a @click="suffixTextTemplate = '\\n#TweetMySlides'">Use this</a></p>
          </div>
          <div id="tooltip-content-usecreditstweet">
            <p>Adds a tweet at the end of the sequence crediting <a href="https://twitter.com/TweetMySlides" target="_blank">@TweetMySlides</a>.</p>
            <p>Feel free to turn this off or edit the text as you see fit.</p>
          </div>

          <!-- </div> -->
          <!-- </section> -->

          <edit-section-slide v-for="(slide, index) in slideSequence.slides"
                              ref="editSectionSlides"
                              :key="index"
                              :slide="slide"
                              :total-slides="slideSequence.totalSlides"
                              :prefix-text-template="prefixTextTemplate"
                              :suffix-text-template="suffixTextTemplate"></edit-section-slide>

          <div class="box">
            <div class="field is-grouped is-grouped-right">
              <p class="control">
                <a class="button is-light"
                    @click="cancel()">
                    <span class="icon is-small">
                    <i class="fa fa-ban"></i>
                  </span>
                  <span>Cancel</span>    
                </a>
              </p>
              <p class="control">
                <a class="button is-info"
                    @click="next()">
                    <span class="icon is-small">
                    <i class="fa fa-check"></i>
                  </span>
                  <span>Next</span>                        
                </a>
              </p>            
            </div>
          </div>

        </div>
        <div class="column"></div>
      </div>

    </div>
  </section>
</template>

<script>
import EditSectionSlide from './EditSectionSlide.vue';

import EditSectionBase from './EditSectionBase.vue';

export default {
  name: "EditSection",

  extends: EditSectionBase,

  props: {
    
  },

  components: {
    EditSectionSlide
  },

  data: function () {
    return {

    };
  },

  watch: {

  },

  methods: {

  }
};
</script>

<style lang="scss" scoped>
.field.is-grouped .button:not(:first-child) {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
}

.field.is-grouped .button:not(:last-child) {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
  margin-right: -1px;
}

.field.is-grouped .button:last-child {
  margin-right: 0;
}

.field-label label {
  min-width: 146px;
}

.image.is-256x144 {
  width: 256px;
  height: 144px;
}

.slide-image {
  width: 256px;
}

.slide-thumb {
  border: 1px solid lightgray;
  // box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
}

.vertical-rule {
  width: 1px;
  align-self: stretch;
  background: lightgray;
  margin-right: 1rem;
}

.vertical-center {
  align-self: center;
}

.content.display-mode {
  min-height: 96px;
}

div.control small.help.counter {
  margin-bottom: 0.75rem;
}

.fa.fa-question-circle-o {
  color: rgba(10, 10, 10, 0.4);
  margin-top: 3px;
}

</style>



// WEBPACK FOOTER //
// src/components/create/EditSection.vue